import { render, staticRenderFns } from "./HistoryCars.vue?vue&type=template&id=219d0bc6&lang=pug&"
import script from "./HistoryCars.vue?vue&type=script&lang=ts&"
export * from "./HistoryCars.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryCars.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
